"use client"

import { CollectionMoleculeReatom } from "@/app/collections/store/index.reatom"
import { TraitsFilter as NftTraitsFilter } from "@/app/nft/search/filters/traits/traits-filter"
import { Trans } from "@lingui/macro"
import { reatomComponent } from "@reatom/react"
import { useSuspenseQuery } from "@tanstack/react-query"
import { useMolecule } from "bunshi/react"
import { Suspense } from "react"
import { ErrorBoundary } from "react-error-boundary"

export function TraitsFilter() {
  return (
    <ErrorBoundary fallback={null}>
      <Suspense fallback={null}>
        <TraitsFilterContentent />
      </Suspense>
    </ErrorBoundary>
  )
}

const TraitsFilterContentent = reatomComponent(() => {
  const { collectionTraitsQueryParamsAtom } = useMolecule(
    CollectionMoleculeReatom,
  )
  const queryParams = collectionTraitsQueryParamsAtom()
  const {
    data: { traits },
  } = useSuspenseQuery(queryParams)

  if (!traits.length) return <Trans>Nothing here yet...</Trans>

  return <NftTraitsFilter availableTraits={traits} />
}, "TraitsFilterContentent")
